// extracted by mini-css-extract-plugin
export default {"model":"Model_model__ZCBa3","model__view":"Model_model__view__HViNc"};